"use client";
import { PiArrowLeft, PiArrowRight } from "react-icons/pi";
import { Universe, UniverseSelect } from "./UniverseSelect";
import { PreviewToggle } from "./PreviewToggle";
import { ExperimentToggle } from "./ExperimentToggle";
import { OverrideUser } from "./OverrideUser";
import { useState } from "react";

export const ToolBarSlider = ({
  universes,
  isEnabled,
}: {
  universes: Universe[];
  isEnabled: boolean;
}) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen((isOpen) => !isOpen)}
        className="flex h-8 w-8 items-center justify-center rounded-full bg-white/75"
      >
        {isOpen ? <PiArrowRight size={24} /> : <PiArrowLeft size={24} />}
      </button>
      {isOpen && (
        <>
          <UniverseSelect universes={universes} />
          <PreviewToggle isEnabled={isEnabled} />
          <ExperimentToggle />
          <OverrideUser />
        </>
      )}
    </>
  );
};
